import React from 'react';
import { Platform, Pressable } from 'react-native';
import { VStack } from '@/components/gluestack/vstack';
import { HStack } from '@/components/gluestack/hstack';
import { Text } from '@/components/gluestack/text';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { useOpenWebPage } from '@/hooks/useOpenWebPage';
import { useTranslation } from 'react-i18next';
import { VERSION_WITH_BUILD } from '@/constants/version';
import AboutDialog from '@/components/ui/AboutDialog';
import { SUPPORT_URLS } from '@/constants/urls';

export function CommunitiesFooter() {
  const insets = useSafeAreaInsets();
  const bottom = insets.bottom;
  const isLargeScreen = useIsLargeScreen();
  const openWebPage = useOpenWebPage();
  const { t } = useTranslation();
  const [isAboutOpen, setIsAboutOpen] = React.useState(false);

  if (!isLargeScreen) return null;

  return (
    <VStack className="bg-neutral-800" style={{ paddingBottom: bottom }}>
      <HStack className="mx-auto w-full max-w-7xl items-center justify-between px-8 py-3">
        <Text size="sm" className="color-white">© Grokio Communities • {VERSION_WITH_BUILD}</Text>
        <HStack className="items-center gap-6">
          <Pressable
            onPress={() => openWebPage(SUPPORT_URLS.atlassian.support.helpCenter)}
            accessibilityRole={Platform.OS === 'web' ? 'link' : 'button'}
            hitSlop={6}
          >
            <Text size="sm" underline className="color-white">{t('footer.support')}</Text>
          </Pressable>
          <Pressable
            onPress={() => openWebPage(SUPPORT_URLS.atlassian.legal.termsOfUse)}
            accessibilityRole={Platform.OS === 'web' ? 'link' : 'button'}
            hitSlop={6}
          >
            <Text size="sm" underline className="color-white">{t('footer.terms')}</Text>
          </Pressable>
          <Pressable
            onPress={() => openWebPage(SUPPORT_URLS.atlassian.legal.privacyPolicy)}
            accessibilityRole={Platform.OS === 'web' ? 'link' : 'button'}
            hitSlop={6}
          >
            <Text size="sm" underline className="color-white">{t('footer.privacy')}</Text>
          </Pressable>
          <Pressable
            onPress={() => setIsAboutOpen(true)}
            accessibilityRole={Platform.OS === 'web' ? 'button' : 'button'}
            hitSlop={6}
          >
            <Text size="sm" underline className="color-white">{t('settings.about.title')}</Text>
          </Pressable>
        </HStack>
      </HStack>
      <AboutDialog isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
    </VStack>
  );
}

export default CommunitiesFooter;


